import { AppMessages } from 'i18n/messages';

/** Polling cadence the screen offers (contract WKD-2488 §4): 3, 5 or 10 seconds. */
export const PRESENCE_REFETCH_INTERVALS = [3000, 5000, 10000] as const;

export const DEFAULT_PRESENCE_REFETCH_INTERVAL = 5000;

/** Interval carried in router state between the tree and the list; anything unexpected falls back to 5 s. */
export const toPresenceRefetchInterval = (value: unknown): (typeof PRESENCE_REFETCH_INTERVALS)[number] =>
  PRESENCE_REFETCH_INTERVALS.find((interval) => interval === value) ?? DEFAULT_PRESENCE_REFETCH_INTERVAL;

export const PRESENCE_REFETCH_INTERVAL_LABELS: Record<(typeof PRESENCE_REFETCH_INTERVALS)[number], string> = {
  3000: AppMessages['events.currentPresence.refresh.threeSeconds'],
  5000: AppMessages['events.currentPresence.refresh.fiveSeconds'],
  10000: AppMessages['events.currentPresence.refresh.tenSeconds'],
};

/** Left indent of every nested tree level (MUI TreeItem group margin, pinned in `PresenceZoneItem.styles`). */
export const PRESENCE_TREE_INDENT = 17;

/** Poziom of the top-level zones on this screen — the root (poziom 1) is not returned (contract R1). */
export const PRESENCE_TOP_POZIOM = 2;

/** KOD + NAZWA area of a top-level row. Nested rows shrink it by their indent, so counters stay at one x. */
export const PRESENCE_NAME_AREA_WIDTH = 360;

/** KOD column inside the name area. */
export const PRESENCE_CODE_COLUMN_WIDTH = 120;

/**
 * Counter block shared by the header and every row: label cell ("ILOŚĆ OSÓB", empty in rows), then
 * STREFA, PODSTREFA, ŁĄCZNIE. It follows the name area directly (design), the action sits at the far right.
 */
export const PRESENCE_COUNTERS_COLUMNS = '110px 135px 150px 130px';

/** Width of the per-row "people in zone" action. */
export const PRESENCE_ACTION_COLUMN = '48px';

export const getPresenceNameAreaWidth = (poziom: number): number =>
  PRESENCE_NAME_AREA_WIDTH - Math.max(0, poziom - PRESENCE_TOP_POZIOM) * PRESENCE_TREE_INDENT;
